import * as Ajax from "../../pwa/ajax";
import * as BucketTools from "../common/bucket";
import * as Utilities from "../common/utilities";
import {sugerenciasPie, cortesSugerencias} from "../../../Settings/global/nota.json";
import * as Cookie from '../common/cookie';

const urlApiCategorias = window.config.Statics.ApiContenidoUrlRoot + "categoriastags?categoriasId=";
const urlApiLogin = window.config.Statics.APILoginUrl;
const bucket = window.config.Statics.BucketUrl;
const urlApiNewsletter = urlApiLogin + window.config.Statics.ApiNewsletterSugerenciaUrl;
const urlApiSuscribirse =  urlApiLogin + window.config.Statics.ApiUrlSuscribirse;
const urlBucket = window.config.Statics.BucketUrl;

/////////////////////////////////////TE PUEDE INTERESAR - NOTA///////////////////////////////////////////////////////////////////
export const sugerencias = () => {
    let notas = JSON.parse(localStorage.getItem("obtenerSugerencias"));
    if (notas != null && notas.length > 0) { 
        
        notas = notas.filter(item => item.datos != null && item.datos.imagen !== null && item.datos.imagen !== undefined);
        
        //Purgar nota actual de listado de sugerencias.
        notas = purgarNotaDeSugerencias(notas);

        let notasBloque1 = notas.slice(0, 7);
        let notasBloque2 = notas.slice(7, 15);
        let notasBloque3 = notas.slice(15, 20);
        let contador = 0;
        let toi = 801;
        let html = `<aside class="puede-interesar" id="bloque-3" data-is-block="true" data-block-name="n_sugerencias" data-diagramacion-id="0">
                    <div class="fila-1 floatFix" id="sugeridasBloque3F1">
                    <h4>Te puede interesar</h4>
                    <div class="columna-doble">${getArticleSugerido(notas[0], 514,137,toi)}</div>`;
    
        let article = "";
        notasBloque1.shift();
        for (var nota of notasBloque1) {
            toi++;
            article += getArticleSugerido(nota, 216,137,toi);
            contador++;
            
            if (contador % 2 === 0) {
                html += `<div class="columna">${article}</div>`;
                article = "";
            }
        }
        html += "</div>";
       
        if(notasBloque2.length === 8)
        {
            html += `<div class="fila-2 floatFix" id="sugeridasBloque3F2">`;
            article = "";
            contador = 0;
            for (var nota of notasBloque2) {
                toi++;
                article += getArticleSugerido(nota, 216,137,toi);
                contador++;
                if (contador % 2 === 0) {
                    html += `<div class="columna">${article}</div>`;
                    article = "";
                }
                if (contador === 5) {
                    toi++;
                    article = getArticleSugerido(nota, 514,137,toi);
                    html += `<div class="columna-doble">${article}</div>`;
                    article = "";
                    contador++;
                }
            }
            html += `</div>`;
        }
        
        if(notasBloque3.length === 5)
        {
            html += `<div class="fila-3 floatFix" id="sugeridasBloque3F3">`;
            for (var nota of notasBloque3) {
                toi++;
                html += getArticleSugerido(nota, 216,137,toi);
            }
            html += `</div></aside>`;
        }        
        document.querySelector('div[data-module="nota-sugeridas"]').innerHTML = html; 
    }
}

const purgarNotaDeSugerencias = (notas) => {
    const notaId = document.querySelector("div[data-notaId]").getAttribute("data-notaId");

    notas.forEach((laNota, index) => {
        if (laNota.contenido_id === parseInt(notaId))
            notas.splice(index, 1);
    });
    return notas;
}

export const getValoresDeCorte = () => {
    const cortes = cortesSugerencias;
    const arrayOpciones = cortes.opciones;
    const randomOption = arrayOpciones[Math.floor(Math.random() * arrayOpciones.length)];

    const objResult = {
        usuario : true,
        dias: [],
        categorias: [],
        horas : [],
        diaYHorario : []
    }

    localStorage.removeItem("sugerenciasTipoCorte");

    switch (randomOption) {
        case "usuario":
            objResult.usuario = true;
            localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("default"));
            break;
        case "usuarioDias":
            {
                const date = new Date();
                let diaDeSemana = date.getDay();
                //TODO: que pasas si pedimos un numero de dia mayor al que estamos? lo validamos?
                diaDeSemana = diaDeSemana === 0 ? 7 : diaDeSemana;
                objResult.dias = [diaDeSemana];
                localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("dia"));
            }
            break;
        case "usuarioCategorias":
            {
                let jsonCategoria = JSON.parse(localStorage.getItem("obtenerPreferibles"));
                jsonCategoria = jsonCategoria.filter(x => x.tipoId === 20);
                
                const arrCategorias = [];
                jsonCategoria.map((o) => {
                    arrCategorias.push(o.id);
                });
                objResult.categorias = arrCategorias;
                localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("categoria"));
            }
            break;
        case "usuarioHoras":
            objResult.horas = getRangoHorario(cortes.rangosDiscretizacion);
            localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("hora"));
            break;
        case "usuarioDiaHorario":
            {
                const date = new Date();
                let diaDeSemana = date.getDay();
                //TODO: que pasas si pedimos un numero de dia mayor al que estamos? lo validamos?
                diaDeSemana = diaDeSemana === 0 ? 7 : diaDeSemana;
                objResult.dias = [diaDeSemana];
                objResult.horas = getRangoHorario(cortes.rangosDiscretizacion);
                localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("fechaYhora"));
            }
            break;
    }
    return objResult;
}   

const getRangoHorario = (arrayRangosHorarios) => {
    //["00,01,02,03,04,05,06,07", "08,09,10", "11,12,13,14", "15,16,17,18", "18,19,20", "20,21,22,23"];

    const date = new Date(); //new Date("July 21, 1983 01:15:00")
    let hora = date.getHours();
    hora = (`0${hora}`).slice(-2);

    let valor;
    arrayRangosHorarios.map((o, index) => {
        o.split(",").find((h) => {
            if (h === hora) valor = index;
        });
    });

    return arrayRangosHorarios[valor];
}

const getArticleSugerido = (nota, width, widthTablet,toi) => {
    let imgHtml = "";
    let toiPos = "toi".concat(toi.toString());
    let tipoCorte = JSON.parse(localStorage.getItem("sugerenciasTipoCorte"));

    if (nota.datos.imagen != null && nota.datos.imagen.id > 0 && nota.datos.imagen.extension != null && nota.datos.imagen.extension != "") {
        imgHtml += `<source media="(min-width: 768px)" srcset="${BucketTools.urlBucketBalance(urlBucket, nota.datos.imagen.id, "", width, nota.datos.imagen.extension)}">`;
        imgHtml += `<img src="${BucketTools.urlBucketBalance(urlBucket, nota.datos.imagen.id, "", widthTablet, nota.datos.imagen.extension)}"/>`;
    }
    
    return `<article title="" class="nota"  data-id="${nota.contenido_id}" data-notaid="${nota.contenido_id}" data-source="sugerencia-${tipoCorte}" data-pos="${toiPos}">
              <a class="figure" href="${nota.contenido_id}-${Utilities.FormatearUrl(nota.titulo)}">         
                <picture>
                     ${imgHtml}
                </picture>
              </a>
              <h2><a href="${nota.contenido_id}-${Utilities.FormatearUrl(nota.titulo)}">${nota.titulo}</a></h2>
          </article>`;
}

const renderNotasPieCategoria = (data , categoriaRandom, idsCategoria, idsTags) => {
    const container = document.getElementById("bloque-4");
    if (!container || data == null) return;
    let heightBucket;
    let widthBucket;
    let conAutor;
    let categoria;
    let listado;
    let toi = 901;
    for (let j = 0; j < categoriaRandom.length; j++) {
        const isCategoriaOTag = (idsCategoria.indexOf(categoriaRandom[j]) > -1) ? "categorias" : "tags";
        if (data[isCategoriaOTag][categoriaRandom[j]].items.length > 0) {
            categoria = (isCategoriaOTag == "categorias") ? data[isCategoriaOTag][categoriaRandom[j]].items[0].categoriaDescripcion :  data[isCategoriaOTag][categoriaRandom[j]].items[0].tags.find(x => x.id == categoriaRandom[j]).valor;
            let categoriaNormalizada = Utilities.FormatearUrl(categoria);
            listado = `<section data-is-block="true" data-block-name="n_recomendacion-${categoriaNormalizada}" data-diagramacion-id="0">`;
            const notas = data[isCategoriaOTag][categoriaRandom[j]].items.slice(0, 5);
            listado += `<h3>${categoria}</h3>`;
            for (let i = 0; i < notas.length; i++) {
                const nota = notas[i];
                const conImagen = nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src !== "";
                (i === 0) ? heightBucket = 183 : heightBucket = 80;
                (i === 0) ? widthBucket = 282 : widthBucket = 107;
                (nota.template_id !== null && nota.template_id == 3) ? conAutor = "autor": conAutor = "";
                let toiPos = "toi".concat(toi.toString());
                listado += `<article class="nota ${conAutor} floatFix" data-id="${nota.id}" data-notaid="${nota.id}" data-source="ultimas" data-pos="${toiPos}">`;

                if (i === 0) {
                    listado += `<a class="figure" href="${nota.url}" "data-numero="${i}" data-tipo="normal-primera">`;
                    listado += conImagen ? `<img src="${BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, heightBucket)}"/>`: "";
                    listado += `</a>`;
                } else {
                    if (conAutor === "") { //conImagen && Si se lo saco qu eonda?
                        listado += `<a class="figure"  href="${nota.url}" data-numero="${i}" data-tipo="normal">`;
                        listado += conImagen ? `<img src="${BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, heightBucket)}"/>`: "";
                        listado += `</a>`;
                    } else if (conAutor !== "" && nota.autores[0].hdImagenId !== null && nota.autores[0].hdImagenExtension) {
                        listado += `<a class="figure"  href="${nota.url}" data-numero="${i}" data-tipo="autor">`;
                        listado += nota.autores instanceof Array && nota.autores.length > 0 && nota.autores[0].hdImagenId != null && nota.autores[0].hdImagenId != 0 && nota.autores[0].hdImagenExtension != null && nota.autores[0].hdImagenExtension != ""
                            ? `<img src="${BucketTools.urlBucketBalance(bucket,nota.autores[0].hdImagenId,heightBucket,"",nota.autores[0].hdImagenExtension)}"/>`
                            : "";
                        listado += `</a>`;
                    }
                }

                listado += `<h2><a href="${nota.url}">${nota.titulo}</a></h2>`;
                if (conAutor !== "" && nota.autores instanceof Array && nota.autores.length > 0 ) {
                    listado += `<a href="${Utilities.formatoUrlAcuAutor(nota.autores[0].valor, nota.autores[0].id)}" class="autor">${nota.autores[0].valor}</a>`;
                }
                listado += `</article>`;
                toi++;
            }
            listado += "</section>";
            container.insertAdjacentHTML("afterbegin", listado);
        }
    }
}

const renderSugerenciaNewsletter = (data) => {
    let suscripcionPendiente = localStorage.getItem("suscripcionPendiente");
    let fechaSuscripcionPendiente = localStorage.getItem("fechaSuscripcionPendiente");
    let token = Cookie.LeerCookie("token");
    let tiempoCacheMilisegundos = 300000;///TODO:Cambiar a configuracion
    let dif = tiempoCacheMilisegundos;

    if (fechaSuscripcionPendiente !== null) {
        dif = Date.now() - fechaSuscripcionPendiente;
    }

    if (token !== "" && suscripcionPendiente !== null && dif < tiempoCacheMilisegundos) {
        let objPendiente = data.filter(p => p.servicioId === parseInt(suscripcionPendiente));
        if (objPendiente.length > 0) {
            let tituloPendiente = objPendiente[0].titulo;
            renderCajaSuscribir(tituloPendiente);
        }

        suscribirNewsletterAjax(data, token, suscripcionPendiente);
        localStorage.removeItem("suscripcionPendiente");
        localStorage.removeItem("fechaSuscripcionPendiente");
    } else if (data.length > 0) {
        if (suscripcionPendiente !== null) {
            localStorage.removeItem("suscripcionPendiente");
            localStorage.removeItem("fechaSuscripcionPendiente");
        }

        let sinSuscripcion = data.filter(d => d.suscripto === 0);
        if (sinSuscripcion.length === 0) {
            return;
        }
  
        let sugerenciasSuscripcion = [];
        for (let i = 0; sinSuscripcion.length > i; i++) {
            sugerenciasSuscripcion.push(sinSuscripcion[i].servicioId);
        }
        
        let newsRandom = Utilities.getRandom(sugerenciasSuscripcion, 1);

        let objSugerencia = newsRandom.length > 0
            ? data.filter(x => x.servicioId === newsRandom[0])
            : [];

        if (objSugerencia.length > 0) {
            let tituloSugerencia = objSugerencia[0].titulo;
            renderCajaSuscribir(tituloSugerencia);
        }

        let btn = document.getElementById("suscribirse");
        if (btn == null)
            return;
        if (token !== "") {
            btn.addEventListener("click", () => { suscribirNewsletterAjax(data, token, newsRandom) });
        } else {
            btn.addEventListener("click", () => { loguearYSuscribir(newsRandom); });
        }
    }
}

const renderCajaSuscribir = (tituloADibujar) => {
    let boton = document.createElement("BUTTON");
    let textoBoton = document.createTextNode("SUSCRIBIRME");
    boton.setAttribute("id", "suscribirse");
    boton.appendChild(textoBoton);

    const containerFinCuerpo = document.getElementsByClassName("fin-cuerpo")[0];
    const containerSegunda = document.getElementsByClassName("segunda floatFix")[0];

    const container = containerFinCuerpo !== undefined
                            ? containerFinCuerpo
                                : containerSegunda !== undefined
                                    ? containerSegunda
                                    : false;
    
    if (!container) return;
    let recomendacion = "<div class='titulares-del-dia'>";
    recomendacion += "<span class='icon-mail-line'></span>";
    recomendacion += `<div><b>${tituloADibujar}</b>`;
    recomendacion += "<p id='textSuscripcion'>Suscribite al newsletter</p>";
    recomendacion += "</div>";
    recomendacion += boton.outerHTML;
    recomendacion += "<span class='load' style='display:none;'></span>";
    recomendacion += "<span id='respuesta' style='display:none;'>¡Ya estás suscripto!</span>";

    recomendacion += "</div>";
    container.insertAdjacentHTML("beforeend", recomendacion);
}
const saveNewsletterLocalStorage = (data) => {
    localStorage.setItem("fechaSugerenciaTitulares", Date.now().toString());
    localStorage.setItem("sugerenciasTitulares", JSON.stringify(data));
    renderSugerenciaNewsletter(data);
}
const saveNewsletterLocalStorageDefault = (data) => {
    localStorage.setItem("sugerenciasTitularesDefault", JSON.stringify(data));
    renderSugerenciaNewsletter(data);
}

export const getSugerenciasPie = () => {
    let data = sugerenciasPie[0].categoriasPosibles.concat(sugerenciasPie[0].tagsPosibles);
    let idsRandoms = Utilities.getRandom(data, sugerenciasPie[0].cantidad);
    let idsCategorias = sugerenciasPie[0].categoriasPosibles.filter(x => idsRandoms.indexOf(x) > -1);
    let idsTags = sugerenciasPie[0].tagsPosibles.filter(x => idsRandoms.indexOf(x) > -1);

    let orderCategorias = JSON.parse(JSON.stringify(idsCategorias)).sort((a, b) => a - b);
    let orderTags = JSON.parse(JSON.stringify(idsTags)).sort((a, b) => a - b);
    let pathCategoriaTags =  orderCategorias.join() + "&tagsId=" + orderTags.join() + "&c=5";
    ////http://beta-api-contenidos.lanacion.com.ar/json/v2/categoriastags?categoriasId=30,120,131,272&tagsId=63583,58215

    Ajax.get(urlApiCategorias + pathCategoriaTags)
        .then((rs) => renderNotasPieCategoria(JSON.parse(rs), idsRandoms, idsCategorias, idsTags));
}

export const getNewsletter = () => {
    const fechaSugerencia = localStorage.getItem("fechaSugerenciaTitulares"),
        sugerenciasData = JSON.parse(localStorage.getItem("sugerenciasTitulares")),
        tokenStorage = localStorage.getItem("token"),
        sugerenciaDataDefault = JSON.parse(localStorage.getItem("sugerenciasTitularesDefault"));
    let tiempoCacheMilisegundos = 300000; ///TODO:Cambiar a configuracion
    let dif = 0;

    if (tokenStorage != null) {
        //se fija que el localstorage tenga datos y el token coincida con el guardado
        if (fechaSugerencia != null && sugerenciasData != null) {
            dif = Date.now() - fechaSugerencia;
            //se fija que no haya vencido el cache
            if (dif < tiempoCacheMilisegundos) {
                renderSugerenciaNewsletter(sugerenciasData);
            } else {
                //vencio el cache entonces va a buscar de nuevo la data actualiza el localstorage y renderea
                obtenerSuscripciones(tokenStorage);
            }
        } else {
            obtenerSuscripciones(tokenStorage);
        }
    } else {
        //Si no esta logueado, se fija que tenga informacion en el LocalStorage
        if (sugerenciaDataDefault != null) {
            // dibuja con la data ya existente
            renderSugerenciaNewsletter(sugerenciaDataDefault);
        } else {
            obtenerSuscripciones("default");
        }
    }
}

const obtenerSuscripciones = (tipo) => {
    if (tipo === "default") {
        Ajax.post(urlApiNewsletter)
            .then(rs => JSON.parse(rs))
            .then(saveNewsletterLocalStorageDefault);
    } else {
        let objHeaders = {
            "X-Token": tipo
        }
        Ajax.post(urlApiNewsletter + "PorUsuario","", objHeaders )
            .then(rs => JSON.parse(rs))
            .then(saveNewsletterLocalStorage);
    }
}

const suscribirNewsletterAjax = (data, token , suscribirse) => {
    let serviciosYaSuscripto = data.filter(s => s.suscripto === 1); 
    let urlSuscribirse = urlApiSuscribirse;
    let stringIds = "";
    if (serviciosYaSuscripto.length > 0) {
        for (let k = 0; serviciosYaSuscripto.length > k; k++) {
            stringIds += serviciosYaSuscripto[k].servicioId + ",";
        }
    }
    stringIds += suscribirse;
    let objParam = {
        "servicios_ids": stringIds,
        "acepta_novedades":null
    }
    let objHeaders = {
        "Content-Type":"application/json",
        "X-Token": token
    }
    suscribirNewsletterLogueado(urlSuscribirse, objParam ,objHeaders);
}

const suscribirNewsletterLogueado = (url ,objParam , objHeaders) => {
    document.getElementById( "suscribirse" ).style.display = "none";
    let load =  document.querySelector(".titulares-del-dia .load");
  //  let respuesta =  document.querySelector(".titulares-del-dia #respuesta");
    load.style.display = "block";
    Ajax.post(urlApiSuscribirse , objParam , objHeaders).then(suscripcionCorrecta).catch(suscripcionError);
    localStorage.removeItem("sugerenciasTitulares");
}

const loguearYSuscribir = (newsRandom) => {
    document.getElementById( "suscribirse" ).style.display = "none";
    let load =  document.querySelector(".titulares-del-dia .load");
    load.style.display = "block";
    localStorage.setItem("tareaPendiente", newsRandom);
    localStorage.setItem("fechaPendiente", Date.now().toString());
    localStorage.removeItem("sugerenciasTitulares");
    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
}

const suscripcionCorrecta = () => {
    //document.getElementById("textSuscripcion").innerText = "¡Ya estás suscripto!";
    let load =  document.querySelector(".titulares-del-dia .load");
    let respuesta =  document.querySelector(".titulares-del-dia #respuesta");
    load.style.display = "none";
    respuesta.style.display = "inline-block";
    setTimeout(function(){ respuesta.classList.add("bg-letter"); }, 200);
    localStorage.removeItem("tareaPendiente");
    localStorage.removeItem("fechaPendiente");
}

const suscripcionError = () => {
    let load =  document.querySelector(".titulares-del-dia .load");
    let respuesta =  document.querySelector(".titulares-del-dia #respuesta");
    load.style.display = "none";
    respuesta.innerHTML = "¡Ups volvé a intentarlo!";
    respuesta.style.display = "inline-block";

   
    //document.getElementById("textSuscripcion").innerText = "¡Ups volvé a intentarlo!";
    document.getElementById( "suscribirse" ).style.display = "block";

}


// WEBPACK FOOTER //
// ./Statics/scripts/nota/sugerencias.js